import {Component, Input} from '@angular/core';

@Component({
    selector: 'tfl-success-block',
    template: `
        <div>
            <div *ngIf="title" class="title">
                {{ title }}
            </div>
            <div><ng-content></ng-content></div>
        </div>
    `
})
export class SuccessBlock {
    @Input('title') title: string = '';
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/components/success/success.block.ts